import type { ReactElement } from 'react'
import { PaperGrad, BeadyEye, STROKE, SHADOW, type GlyphProps } from './shared'

/* JUMPING FROG — angular pointed snout, side view with diamond body */
export const Frog = ({ size = 110 }: GlyphProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 120 120" style={SHADOW}>
    <defs>
      <PaperGrad id="frog-l" light="#dff3df" dark="#a4d8a8"/>
      <PaperGrad id="frog-d" light="#a4d8a8" dark="#6ea872"/>
    </defs>
    {/* back legs */}
    <polygon points="10,100 58,68 48,96" fill="url(#frog-d)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <polygon points="110,100 62,68 72,96" fill="url(#frog-d)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="20" y1="92" x2="50" y2="74" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="100" y1="92" x2="70" y2="74" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* body diamond pointing up */}
    <polygon points="60,12 96,64 60,98 24,64" fill="url(#frog-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    {/* shaded back fold */}
    <polygon points="60,12 24,64 60,60" fill="url(#frog-d)" opacity="0.7" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2" strokeLinejoin="round"/>
    {/* center crease */}
    <line x1="60" y1="12" x2="60" y2="98" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="24" y1="64" x2="96" y2="64" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* eye bumps */}
    <BeadyEye cx={48} cy={48} r={2}/>
    <BeadyEye cx={72} cy={48} r={2}/>
  </svg>
)
